export default __webpack_public_path__ + "static/media/medium.0f89835a.png";